const logger = (store) => (next) => (action) => {
  console.log(
    `Action type: ${action.type} and Action Payload ${action.payload}`
  );
  return next(action);
};

export default logger;
